var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2751 11.9416C17.7959 11.4208 17.7959 10.575 17.2751 10.0541L9.27509 2.05413C8.75425 1.5333 7.90842 1.5333 7.38758 2.05413C6.86675 2.57497 6.86675 3.4208 7.38758 3.94163L14.4459 11L7.39175 18.0583C6.87092 18.5791 6.87092 19.425 7.39175 19.9458C7.91258 20.4666 8.75842 20.4666 9.27925 19.9458L17.2793 11.9458L17.2751 11.9416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/Right.5632311cdc497d596649a0b62d23b756.svg";
export { ForwardRef as ReactComponent };